module.exports = __webpack_public_path__ + "images/help/icon-twr62@2x-e020e566495d0496be2a19ad72e6eb6c.png";